import { IconButton, IconButtonProps } from '@mui/material';
import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

interface NavigateIconButtonProps extends IconButtonProps {
    to: string;
    children: ReactNode;
}

const NavigateIconButton: React.FC<NavigateIconButtonProps> = ({ to, children, ...props }) => {
    const navigate = useNavigate();

    const handleClick = React.useCallback(() => {
        navigate(to);
    }, [navigate, to]);

    return (
        <IconButton onClick={handleClick} {...props}>
            {children}
        </IconButton>
    );
};

export default NavigateIconButton;